"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var QueueItem = /*#__PURE__*/_createClass(function QueueItem(onLoad, onError, dependentItem) {
  _classCallCheck(this, QueueItem);
  this.onLoad = onLoad;
  this.onError = onError;
  this.data = null;
  this.error = null;
  this.dependentItem = dependentItem;
});
/**
 * AsyncResourceQueue is the queue in charge of run the async scripts
 * and notify when they finish.
 */
module.exports = /*#__PURE__*/function () {
  function AsyncResourceQueue() {
    _classCallCheck(this, AsyncResourceQueue);
    this.items = new Set();
    this.dependentItems = new Set();
  }
  _createClass(AsyncResourceQueue, [{
    key: "count",
    value: function count() {
      return this.items.size + this.dependentItems.size;
    }
  }, {
    key: "_notify",
    value: function _notify() {
      if (this._listener) {
        this._listener();
      }
    }
  }, {
    key: "_check",
    value: function _check(item) {
      var _this = this;
      var promise;
      if (item.onError && item.error) {
        promise = item.onError(item.error);
      } else if (item.onLoad && item.data) {
        promise = item.onLoad(item.data);
      }
      promise.then(function () {
        _this.items["delete"](item);
        _this.dependentItems["delete"](item);
        if (_this.count() === 0) {
          _this._notify();
        }
      });
    }
  }, {
    key: "setListener",
    value: function setListener(listener) {
      this._listener = listener;
    }
  }, {
    key: "push",
    value: function push(request, onLoad, onError, dependentItem) {
      var q = this;
      var item = new QueueItem(onLoad, onError, dependentItem);
      q.items.add(item);
      return request.then(function (data) {
        item.data = data;
        if (dependentItem && !dependentItem.finished) {
          q.dependentItems.add(item);
          return q.items["delete"](item);
        }
        if (onLoad) {
          return q._check(item);
        }
        q.items["delete"](item);
        if (q.count() === 0) {
          q._notify();
        }
        return null;
      })["catch"](function (err) {
        item.error = err;
        if (dependentItem && !dependentItem.finished) {
          q.dependentItems.add(item);
          return q.items["delete"](item);
        }
        if (onError) {
          return q._check(item);
        }
        q.items["delete"](item);
        if (q.count() === 0) {
          q._notify();
        }
        return null;
      });
    }
  }, {
    key: "notifyItem",
    value: function notifyItem(syncItem) {
      var _iterator = _createForOfIteratorHelper(this.dependentItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.dependentItem === syncItem) {
            this._check(item);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
  return AsyncResourceQueue;
}();